/* global address google */

import { stylesMap } from "./style"
import SmoothScroll from "smooth-scroll"
const scroll = new SmoothScroll('.up a[href*="#"]')

// Карта на странице контактов
const mapInit = () => {
  const buttonsToMap = Array.from(document.querySelectorAll("a[data-marker]"))
  if (document.getElementById("contactsMap")) {
    const mapStores = new google.maps.Map(document.getElementById("contactsMap"), {
      scrollwheel: false,
      zoom: 8,
      center: new google.maps.LatLng(address[0].lat, address[0].lng),
      streetViewControl: false,
      mapTypeControl: false,
      styles: stylesMap,
      scaleControl: false,
      zoomControl: true,
      fullscreenControl: false
    })

    const markers = address.map((adr, index) => {
      return new google.maps.Marker({
        icon: setMarker(adr.companyInfo.type),
        position: new google.maps.LatLng(adr.lat, adr.lng),
        map: mapStores,
        optimized: false,
        crossOnDrag: false,
        zIndex: index === 0 ? 10 : 1
      })
    })

    const bounds = new google.maps.LatLngBounds()

    address.map(adr => {
      bounds.extend(new google.maps.LatLng(adr.lat, adr.lng))
    })

    mapStores.fitBounds(bounds)
    mapStores.panToBounds(bounds)

    markers.map((marker, index) => {
      const infowindow = new google.maps.InfoWindow({
        content: `<div class="contactsMapInfoBox"><h2>${address[index].companyInfo.name}</h2><p>${
          address[index].companyInfo.address
        }</p></div>`
      })
      marker.addListener("click", () => {
        infowindow.open(mapStores, marker)
      })
    })

    buttonsToMap.map((button, index) => {
      button.addEventListener("click", e => {
        e.preventDefault()
        scroll.animateScroll(document.querySelector("#contactsMap"), null, {
          offset: 250
        })
        setTimeout(() => {
          mapStores.panTo(new google.maps.LatLng(address[index].lat, address[index].lng))
          mapStores.setZoom(Math.max(16, mapStores.getZoom() + 1))
        }, 500)
      })
    })
  }
}

const setMarker = type => {
  const icon =
    type === "office"
      ? "/local/templates/maltru/img/icon-map-office.svg"
      : "/local/templates/maltru/img/icon-map-stock.svg"
  return new google.maps.MarkerImage(
    icon,
    new google.maps.Size(52, 52),
    new google.maps.Point(0, 0),
    new google.maps.Point(26, 26),
    new google.maps.Size(52, 52)
  )
}

export default mapInit
